import React, {Component} from 'react';
import {gpn} from "../GPN"
import Icon from "../sections/MUI/Icon";

class ErrorPayment extends Component {

    state = {};

    componentDidMount() {
        this.props.setTitle("پرداخت ناموفق");
    }


    render() {
        return (
            <div className="payment error">
                <Icon i="times-circle"/>
                <div className="message">پرداخت شما ناموفق بوده است. در صورت کسر وجه، تا 72 ساعت آینده به حساب شما عودت
                    داده خواهد شد.
                </div>
            </div>
        );
    }
}

export default gpn(ErrorPayment);